import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  deviceText: {
    whiteSpace: 'nowrap',
    marginRight: theme.spacing(1.3),
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    flexGrow: 0,
  },
}));

export default useStyles;
